import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import { geoUnitListSchema, type GeoUnit } from '../types/geo.types';

const DISTRICT_LEVEL = 'district';

export const geoQueryKeys = {
  all: () => ['geo'] as const,
  divisions: () => [...geoQueryKeys.all(), 'divisions'] as const,
  allDistricts: () => [...geoQueryKeys.all(), 'districts', 'all'] as const,
  districts: (divisionId: number) => [...geoQueryKeys.all(), 'districts', divisionId] as const,
  thanas: (districtId: number) => [...geoQueryKeys.all(), 'thanas', districtId] as const,
};

export const divisionListQueryOptions = () =>
  queryOptions({
    queryKey: geoQueryKeys.divisions(),
    queryFn: async (): Promise<GeoUnit[]> => {
      const res = await apiClient.get(API.geo.divisions);
      return geoUnitListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const allDistrictListQueryOptions = () =>
  queryOptions({
    queryKey: geoQueryKeys.allDistricts(),
    queryFn: async (): Promise<GeoUnit[]> => {
      const res = await apiClient.get(API.geo.units, {
        params: { level: DISTRICT_LEVEL },
      });
      return geoUnitListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const districtListQueryOptions = (divisionId: number) =>
  queryOptions({
    queryKey: geoQueryKeys.districts(divisionId),
    queryFn: async (): Promise<GeoUnit[]> => {
      const res = await apiClient.get(API.geo.districts, {
        params: { divisionId },
      });
      return geoUnitListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const thanaListQueryOptions = (districtId: number) =>
  queryOptions({
    queryKey: geoQueryKeys.thanas(districtId),
    queryFn: async (): Promise<GeoUnit[]> => {
      const res = await apiClient.get(API.geo.thanas, {
        params: { districtId },
      });
      return geoUnitListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
